import * as Sentry from '@sentry/react';
import type { ReactNode } from 'react';

export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={({ resetError }) => (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
        <div className="max-w-md rounded-2xl border bg-white p-8 shadow-sm text-center">
          <h1 className="text-xl font-bold text-slate-900">Something went wrong</h1>
          <p className="mt-2 text-sm text-slate-500">The error was recorded. Reload this section to continue.</p>
          <button className="mt-5 rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white" onClick={resetError}>Try again</button>
        </div>
      </div>
    )}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
